import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchResult } from 'src/app/models/searchresult.interface';
import { SearchService } from 'src/app/services/search/search.service';

@Component({
    selector: '[appSearch]',
    templateUrl: './search.page.html',
    styleUrls: ['./search.page.scss'],
    standalone: false,
})
export class SearchPage implements OnInit {
    public initial: boolean = true;
    public value: any;
    public searched = '';
    public error: string | null = null;
    public searchResults: SearchResult[] = [];
    public isSearching: boolean = false;
    public loadingColor: string = 'surface';
    private searchElement?: HTMLInputElement;
    public searchService = inject(SearchService);
    private readonly route = inject(ActivatedRoute);

    constructor() {
        if (this.route.snapshot.queryParams?.['searchTerm']) {
            this.value = this.route.snapshot.queryParams?.['searchTerm'];
            this.initSearch();
        }

        this.searchService.results.subscribe({
            next: (result) => {
                this.searchResults.push(result);
            },
        });

        this.searchService.searching$.subscribe({
            next: (value) => {
                this.isSearching = value;
            },
        });

        this.searchService.error$.subscribe({
            next: (value) => {
                this.error = value;
            },
        });
    }

    ngOnInit(): void {
        this.searchElement = document.getElementById(
            'search',
        ) as HTMLInputElement;
        this.searchElement.addEventListener('input', () => {
            if (this.value == '') {
                this.initial = true;
            }
        });
    }

    getSearchResultRouterLink(path: string): string[] {
        if (!path) {
            return ['/build'];
        }

        try {
            const url = new URL(path.trim(), window.location.origin);
            // Decode the entire pathname first, then split by /
            const decodedPath = decodeURIComponent(url.pathname);
            const segments = decodedPath.split('/').filter(Boolean);

            if (segments.length === 0) {
                return ['/build'];
            }

            if (segments[0]?.toLowerCase() === 'build') {
                segments.shift();
            }

            return ['/build', ...segments];
        } catch {
            return ['/build'];
        }
    }

    resetForm(): void {
        this.value = '';
        this.initSearch();
        this.initial = true;
    }

    onSubmit(): void {
        this.initSearch();
    }

    initSearch(): void {
        this.searched = this.value;
        this.searchResults = [];
        this.initial = false;
        this.searchService.searchContent(this.value, {
            open: '<strong>',
            close: '</strong>',
        });
    }
}
